import React from 'react'
import classNames from 'classnames'

import './side-menu.scss'
import Stamp from '../../assets/stamp-sidemenu.png'
import fb from '../../assets/fb.png'
import email from '../../assets/email.png'
import instagram from '../../assets/instagram.png'

class SideMenu extends React.Component {
  componentDidMount() {}

  render() {
    return (
      <div
        className={classNames(
          'side-menu text-center mt-3 col-lg-2 order-last order-md-first pr-0 pr-sm-3',
          {
            'd-none d-lg-block':
              (typeof window !== 'undefined' && window.location.pathname === '/story') ||
              (typeof window !== 'undefined' && window.location.pathname === '/menu') ||
              (typeof window !== 'undefined' && window.location.pathname === '/caterer') ||
              (typeof window !== 'undefined' && window.location.pathname === '/press')
          }
        )}
      >
        <div className="mb-2">
          <img src={Stamp} height="100" />
        </div>

        <div className="d-flex justify-content-center mt-3 mb-3">
          <div className="phone-number pt-2 pb-2">+ 33 1 71 93 48 75</div>
        </div>

        <div>MIDI</div>
        <div>12h00 – 14h30</div>
        <div>SOIR</div>
        <div>19h – 22h</div>
        <div className="mt-2">FERMÉ</div>
        <div>LE DIMANCHE</div>
        <div className="mb-5">& LUNDI SOIR</div>

        <div className="mb-2 title-red">
          <div className="box-red">
            N &deg; 51
            <br />
            RUE DES VINAIGRIERS
            <br />
            PARIS 10
          </div>
        </div>

        <div className="d-flex justify-content-center mt-3 mb-3">
          <div className="phone-number pt-2 pb-2">+ 33 1 83 87 47 82</div>
        </div>

        <div>MIDI</div>
        <div>12h00 – 14h30</div>
        <div>SOIR</div>
        <div>19h – 22h</div>
        <div className="mt-2">FERMÉ</div>
        <div>SAMEDI SOIR</div>
        <div className="mb-2">& DIMANCHE</div>

        <div>
          <a
            className="clickable mr-3"
            href="https://www.instagram.com/banoirestaurant/"
            target="_blank"
          >
            <img src={instagram} width="25" />
          </a>

          <a
            className="clickable mr-3"
            href="https://www.facebook.com/banoirestaurant/"
            target="_blank"
          >
            <img src={fb} width="25" />
          </a>
          <a className="clickable" href="mailto:contact@banoi.fr">
            <img src={email} width="25" />
          </a>
        </div>
      </div>
    )
  }
}

export default SideMenu



// WEBPACK FOOTER //
// ./src/components/SideMenu/SideMenu.js